__turbopack_context__.v({
  "loader": "limited-access-clp-module-scss-module__nCyd-G__loader",
});
